var _defs, _circle, _path, _path2, _circle2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotonesSvg17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2503.45 1222.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d91111;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        filter: url(#drop-shadow-42);\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        filter: url(#drop-shadow-41);\n      }\n\n      .cls-5 {\n        fill: #a81414;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-41",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#26130a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-42",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#26130a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 606.33,
    cy: 611.08,
    r: 525.8,
    transform: "translate(-254.51 607.72) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m2196.05,341.64H728.6v545.98h1467.45c125.29,0,226.86-101.57,226.86-226.86v-92.26c0-125.29-101.57-226.86-226.86-226.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2228.57,384.68H802.21v459.89h1426.37c80.26,0,145.55-103.15,145.55-229.94s-65.3-229.94-145.55-229.94Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 606.33,
    cy: 611.08,
    r: 387.04
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1166.37,671.55c-5.43-5.89-8.15-14.2-8.15-24.93v-73.8c0-10.73,2.71-19.04,8.15-24.93,5.43-5.89,13.31-8.83,23.65-8.83s18.22,2.94,23.65,8.83c5.43,5.89,8.15,14.2,8.15,24.93v14.53h-20.41v-15.9c0-8.5-3.6-12.76-10.8-12.76s-10.8,4.25-10.8,12.76v76.75c0,8.38,3.6,12.56,10.8,12.56s10.8-4.19,10.8-12.56v-21h20.41v19.43c0,10.73-2.72,19.04-8.15,24.93-5.43,5.89-13.32,8.83-23.65,8.83s-18.22-2.94-23.65-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1271.09,541.02h29.25l22.38,137.4h-21.59l-3.93-27.28v.39h-24.54l-3.93,26.89h-20.02l22.38-137.4Zm23.55,91.86l-9.62-67.92h-.39l-9.42,67.92h19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1352.74,541.02h21.59v117.77h35.53v19.63h-57.12v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1439.89,541.02h21.59v137.4h-21.59v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1497.21,541.02h57.12v19.63h-35.53v38.28h27.87v19.63h-27.87v59.87h-21.59v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1584.36,541.02h21.59v137.4h-21.59v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1648.44,671.55c-5.43-5.89-8.15-14.2-8.15-24.93v-73.8c0-10.73,2.71-19.04,8.15-24.93,5.43-5.89,13.31-8.83,23.65-8.83s18.22,2.94,23.65,8.83c5.43,5.89,8.15,14.2,8.15,24.93v14.53h-20.41v-15.9c0-8.5-3.6-12.76-10.8-12.76s-10.8,4.25-10.8,12.76v76.75c0,8.38,3.6,12.56,10.8,12.56s10.8-4.19,10.8-12.56v-21h20.41v19.43c0,10.73-2.72,19.04-8.15,24.93-5.43,5.89-13.32,8.83-23.65,8.83s-18.22-2.94-23.65-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1753.16,541.02h29.25l22.38,137.4h-21.59l-3.93-27.28v.39h-24.54l-3.93,26.89h-20.02l22.38-137.4Zm23.55,91.86l-9.62-67.92h-.39l-9.42,67.92h19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1834.81,541.02h32.98c10.73,0,18.78,2.88,24.14,8.64,5.36,5.76,8.05,14.2,8.05,25.32v69.49c0,11.12-2.68,19.56-8.05,25.32-5.37,5.76-13.42,8.64-24.14,8.64h-32.98v-137.4Zm32.58,117.77c3.53,0,6.25-1.05,8.15-3.14,1.9-2.09,2.85-5.5,2.85-10.21v-71.45c0-4.71-.95-8.11-2.85-10.21-1.9-2.09-4.61-3.14-8.15-3.14h-10.99v98.14h10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1941.01,671.35c-5.63-6.02-8.44-14.53-8.44-25.52v-72.23c0-10.99,2.81-19.5,8.44-25.52,5.62-6.02,13.74-9.03,24.34-9.03s18.71,3.01,24.34,9.03c5.62,6.02,8.44,14.53,8.44,25.52v72.23c0,10.99-2.82,19.5-8.44,25.52-5.63,6.02-13.74,9.03-24.34,9.03s-18.71-3.01-24.34-9.03Zm35.53-24.14v-74.98c0-9.03-3.73-13.54-11.19-13.54s-11.19,4.51-11.19,13.54v74.98c0,9.03,3.73,13.54,11.19,13.54s11.19-4.51,11.19-13.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2032.28,541.02h32c11.12,0,19.24,2.59,24.34,7.75,5.1,5.17,7.66,13.12,7.66,23.85v8.44c0,14.26-4.71,23.29-14.13,27.09v.39c5.23,1.57,8.93,4.78,11.09,9.62,2.16,4.84,3.24,11.32,3.24,19.43v24.14c0,3.93.13,7.1.39,9.52.26,2.42.91,4.81,1.96,7.16h-21.98c-.79-2.22-1.31-4.32-1.57-6.28-.26-1.96-.39-5.5-.39-10.6v-25.12c0-6.28-1.02-10.66-3.04-13.15-2.03-2.48-5.53-3.73-10.5-3.73h-7.46v58.89h-21.59v-137.4Zm29.44,58.89c4.32,0,7.56-1.11,9.72-3.34,2.16-2.22,3.24-5.95,3.24-11.19v-10.6c0-4.97-.88-8.57-2.65-10.8-1.77-2.22-4.55-3.34-8.34-3.34h-9.81v39.26h7.85Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m441.4,446.16c0-30.36,24.61-54.98,54.98-54.98h219.9c30.36,0,54.98,24.61,54.98,54.98v329.85c0,30.36-24.61,54.98-54.98,54.98h-219.9c-30.36,0-54.98-24.61-54.98-54.98v-329.85Zm54.98,13.74v54.98c0,7.59,6.15,13.74,13.74,13.74h192.41c7.59,0,13.74-6.15,13.74-13.74v-54.98c0-7.59-6.15-13.74-13.74-13.74h-192.41c-7.59,0-13.74,6.15-13.74,13.74Zm0,109.95v27.49c0,7.59,6.15,13.74,13.74,13.74h27.49c7.59,0,13.74-6.15,13.74-13.74v-27.49c0-7.59-6.15-13.74-13.74-13.74h-27.49c-7.59,0-13.74,6.15-13.74,13.74Zm13.74,68.72c-7.59,0-13.74,6.15-13.74,13.74v27.49c0,7.59,6.15,13.74,13.74,13.74h27.49c7.59,0,13.74-6.15,13.74-13.74v-27.49c0-7.59-6.15-13.74-13.74-13.74h-27.49Zm-13.74,96.21v27.49c0,7.59,6.15,13.74,13.74,13.74h27.49c7.59,0,13.74-6.15,13.74-13.74v-27.49c0-7.59-6.15-13.74-13.74-13.74h-27.49c-7.59,0-13.74,6.15-13.74,13.74Zm96.21-178.67c-7.59,0-13.74,6.15-13.74,13.74v27.49c0,7.59,6.15,13.74,13.74,13.74h27.49c7.59,0,13.74-6.15,13.74-13.74v-27.49c0-7.59-6.15-13.74-13.74-13.74h-27.49Zm-13.74,96.21v27.49c0,7.59,6.15,13.74,13.74,13.74h27.49c7.59,0,13.74-6.15,13.74-13.74v-27.49c0-7.59-6.15-13.74-13.74-13.74h-27.49c-7.59,0-13.74,6.15-13.74,13.74Zm13.74,68.72c-7.59,0-13.74,6.15-13.74,13.74v27.49c0,7.59,6.15,13.74,13.74,13.74h27.49c7.59,0,13.74-6.15,13.74-13.74v-27.49c0-7.59-6.15-13.74-13.74-13.74h-27.49Zm68.72-151.18v27.49c0,7.59,6.15,13.74,13.74,13.74h27.49c7.59,0,13.74-6.15,13.74-13.74v-27.49c0-7.59-6.15-13.74-13.74-13.74h-27.49c-7.59,0-13.74,6.15-13.74,13.74Zm13.74,68.72c-7.59,0-13.74,6.15-13.74,13.74v109.95c0,7.59,6.15,13.74,13.74,13.74h27.49c7.59,0,13.74-6.15,13.74-13.74v-109.95c0-7.59-6.15-13.74-13.74-13.74h-27.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotonesSvg17);
export default __webpack_public_path__ + "static/media/BOTONES_SVG 17.e506c8479090d9f11ce29c9dfda1618b.svg";
export { ForwardRef as ReactComponent };